import axios from '@/axios';

export default {
    fetchPages(_context,data) {
        return new Promise((resolve, reject) => {
            axios.get('/api/v1/admins/page-management?page='+data.page+'&limit='+data.limit+'&search='+data.search+'&sort='+data.sort+'&dir='+data.dir)
              .then((res) => {
                resolve(res);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    fetchPageDetails(_context,id){
        return new Promise((resolve,reject)=>{
            axios.get('/api/v1/admins/page-management/'+id).then((res) => {
                resolve(res);
        }).catch(err =>{
            reject(err);
        });
    });
    },
    updatePageDetails(_context,data){
        return new Promise((resolve,reject)=>{
            axios.post('/api/v1/admins/page-management/update/'+data.id,data.info).then((res) => {
                resolve(res);
        }).catch(err =>{
            reject(err);
        });
    });
    },

    fetchPageDetailsBySlug(_context,slug){
        return new Promise((resolve,reject)=>{
            axios.get('/api/v1/getPage?slug='+slug).then((res) => {
                resolve(res);
        }).catch(err =>{
            reject(err);
        });
    });
    },

};
